// Przestrzeń nazw 'dashboard': ekran Pulpit. Kolejność jak w mockupie (renderPulpit): kafelki KPI,
// rozmowy według godzin, tematy, skuteczność bota, trend, ostatnie rozmowy.
export default {
  // Kafelki KPI. Jednostki („godz.", „min") są w metrics.units.
  kpis: {
    calls: {
      label: 'Odebrane rozmowy {{range}}',
      // Mockup: „dziś" / „w 7 dni" / „w 30 dni". Nasze presety to okna kroczące.
      // VERIFY: „24 godz.", „3 dni", „rok" i „własny" własne. „Dziś" byłoby nieprawdą dla okna 24 h.
      range: {
        '24h': 'w ciągu 24 godzin',
        '3d': 'w 3 dni',
        '7d': 'w 7 dni',
        '30d': 'w 30 dni',
        '1y': 'w ciągu roku',
        custom: 'w wybranym okresie',
      },
      // VERIFY: mockup ma „100% połączeń odebranych od razu"; tu liczby nie ma, bo wartość jest
      // w kafelku, a przy niej delta, więc podpis jest zdaniem samodzielnym.
      note: 'odebrane najpierw przez asystenta',
    },
    resolved: {
      label: 'Sprawy załatwione przez bota',
      // VERIFY: mockup ma „bez angażowania urzędnika"; kod dopowiada, że podstawą są odebrane
      // rozmowy (nie wszystkie połączenia), i ten mianownik zostaje w tekście.
      note: 'z odebranych rozmów, bez angażowania urzędnika',
    },
    handedOff: {
      label: 'Przekazane do urzędnika',
      note: 'z zapisanym numerem i tematem sprawy',
    },
    timeSaved: {
      label: 'Zaoszczędzony czas pracy',
      note: 'licząc {{minutes}} min pracy urzędnika na sprawę',
    },
    afterHours: {
      label: 'Rozmowy poza godzinami pracy',
      note: 'wieczory, weekendy i święta',
    },
    averageDuration: {
      label: 'Średni czas rozmowy',
      note: 'od odebrania do załatwienia sprawy',
    },
    rating: {
      label: 'Średnia ocena rozmów',
      note_one: '{{count, number}} ocena mieszkańca',
      note_few: '{{count, number}} oceny mieszkańców',
      note_many: '{{count, number}} ocen mieszkańców',
      note_other: '{{count, number}} oceny mieszkańców',
    },
    // Kafelek wyliczony z liczb demo, widoczny tylko przy VITE_SHOW_DEMO_DATA.
    appointments: {
      label: 'Umówione wizyty',
      note: 'z potwierdzeniem SMS',
    },
  },

  // Godziny pracy urzędu, składane w `officeWindow` (dashboard.utils) i pokazywane jako podpis
  // karty „Rozmowy według godzin".
  office: {
    // `hours` to „07:30 – 15:30".
    hours: 'Godziny pracy urzędu: {{hours}}',
    // VERIFY: cały blok poniżej, brak w mockupie (mockup zna tylko jeden stały zakres godzin).
    unavailable: 'Godziny pracy urzędu są niedostępne',
    allDay: 'Otwarte przez cały dzień',
    closedToday: 'Dziś zamknięte',
    closedEveryDay: 'Zamknięte przez cały ten okres',
    widest: 'Godziny pracy urzędu: {{open}} – {{close}} (najszerzej w tym okresie)',
    checking: 'Sprawdzanie godzin pracy urzędu…',
    allCompanies: 'Wszystkie widoczne firmy, jeden zegar dla wszystkich',
  },

  hours: {
    title: 'Rozmowy według godzin',
    // VERIFY: brak w mockupie, etykieta wykresu dla czytnika ekranu.
    chartLabel: 'Rozmowy według godziny doby',
    legend: {
      inHours: 'w godzinach pracy',
      outOfHours: 'poza godzinami pracy',
    },
    // VERIFY: mockup dopisuje „— te telefony wcześniej pozostawały bez odpowiedzi". To
    // twierdzenie produktowe, którego dane nie potwierdzają, więc zostało pominięte.
    afterHoursNote: '{{percent}}% rozmów odbyło się, gdy urząd był zamknięty.',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać rozmów według godzin.',
      loading: 'Ładowanie rozmów według godzin…',
      unavailable: 'Rozmowy według godzin są tu niedostępne.',
      empty: 'Brak rozmów w tym okresie.',
    },
  },

  topics: {
    title: 'Tematy rozmów',
    hint: 'Czego dotyczyły telefony mieszkańców',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać tematów.',
      loading: 'Ładowanie tematów…',
      empty: 'Brak tematów w tym okresie.',
    },
  },

  effectiveness: {
    title: 'Skuteczność bota',
    // VERIFY: mockup ma „Udział spraw załatwionych bez urzędnika"; kod liczy udział odebranych
    // rozmów, i tego mianownika nie chcemy gubić.
    hint: 'Udział odebranych rozmów zamkniętych bez urzędnika',
    caption: 'spraw załatwia bot',
    resolved: 'Rozwiązane w rozmowie',
    handedOff: 'Przekazane do urzędnika',
    // VERIFY: brak w mockupie.
    error: 'Nie udało się wczytać skuteczności.',
  },

  trend: {
    title: 'Rozmowy {{range}}',
    hint: {
      daily: 'Dzienna liczba połączeń obsłużonych przez asystenta',
      // VERIFY: brak w mockupie (mockup zna tylko wykres dzienny).
      hourly: 'Godzinowa liczba połączeń obsłużonych przez asystenta',
    },
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać liczby rozmów.',
      empty: 'Brak rozmów obsłużonych przez asystenta w tym okresie.',
    },
  },

  recent: {
    title: 'Ostatnie rozmowy',
    hint: 'Kliknij rozmowę, aby zobaczyć transkrypcję i odsłuchać nagranie',
    seeAll: 'Zobacz wszystkie rozmowy →',
  },

  // VERIFY: brak w mockupie.
  errors: {
    metrics: 'Nie udało się wczytać metryk rozmów, więc poniższe dane są niepełne.',
  },
} as const;
